import { routes } from 'lib/routes'

export const getMembershipUrl = ({
  infoLink,
  guestId,
  venueId,
  venueSlug,
}: {
  infoLink?: string | null
  guestId?: string
  venueId?: string
  venueSlug: string
}): URL | undefined => {
  if (!infoLink || !guestId || !venueId) {
    return undefined
  }

  try {
    const membershipUrl = new URL(infoLink)

    const encodeGuest = Buffer.from(`Guest:${guestId}`).toString('base64')
    const encodeVenue = Buffer.from(`Venue:${venueId}`).toString('base64')
    const referrer = new URLSearchParams(window.location.search).get('referrer')

    const { protocol, hostname } = window.location
    const returnUri = new URL(
      `${protocol}//${hostname}${routes.venue.toPath!({
        venueSlug,
      })}`,
    )

    membershipUrl.searchParams.append('guest_id', encodeGuest)
    membershipUrl.searchParams.append('venue_id', encodeVenue)
    membershipUrl.searchParams.append('return_uri', returnUri.toString())

    if (referrer) {
      membershipUrl.searchParams.append('referrer', referrer)
    }

    return membershipUrl
  } catch {
    return undefined
  }
}
